import { z } from "zod";

export const buildCompanySettingsSchema = (t: (key: string, opts?: Record<string, string>) => string) =>
  z.object({
    firstName: z
      .string()
      .trim()
      .nonempty({ message: t("validation.firstNameRequired") })
      .min(2, { message: t("validation.firstNameMin") })
      .max(100, { message: t("validation.firstNameMax") }),
    lastName: z
      .string()
      .trim()
      .nonempty({ message: t("validation.lastNameRequired") })
      .min(2, { message: t("validation.lastNameMin") })
      .max(100, { message: t("validation.lastNameMax") }),
    phone: z
      .string()
      .trim()
      .nonempty({ message: t("validation.phoneRequired") })
      .min(9, { message: t("validation.phoneMin") })
      .max(15, { message: t("validation.phoneMax") }),
    companyName: z
      .string()
      .trim()
      .nonempty({ message: t("validation.clinicRequired") })
      .min(2, { message: t("validation.clinicMin") })
      .max(100, { message: t("validation.clinicMax") }),
    languageId: z.string().min(1, { message: t("validation.languageRequired") }),
    confirmation: z.boolean().refine((val) => val === true, {
      message: t("validation.confirmation"),
    }),
    templateId: z.string().nonempty({ message: t("validation.templateRequired") }),
  });
